<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import IconSelected from '@/comps-sdk/components/icon/icon-selected.svelte';

  interface PanelItem {
    [key: string]: string;
    name: string;
    id: string;
  }

  export let options: Array<PanelItem> = [];
  export let selectedValue = {
    id: '',
    name: '',
  };

  const dispatch = createEventDispatcher();
  const handleItemClick = (option: PanelItem) => {
    dispatch('change', option);
  };
</script>

<div class={`select-panel-wrapper ${$$restProps.class || ''}`}>
  {#each options as option}
    <div
      role="button"
      tabindex="0"
      class="panel-item"
      class:selected={option.id === selectedValue.id}
      on:click={() => {
        handleItemClick(option);
      }}
      on:keydown={() => {}}
    >
      <span>{option.name}</span>
      {#if option.id === selectedValue.id}
        <span>
          <IconSelected />
        </span>
      {/if}
    </div>
  {/each}
</div>

<style lang="scss">
  .select-panel-wrapper {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #191919;
    .panel-item {
      position: relative;
      padding: 15px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &.selected {
        color: #ff7000;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        transform: scaleY(50%);
        height: 1px;
        background: rgba(36, 36, 42, 0.4);
      }
    }
  }
</style>
